/** Auth/register language follows the legacy product rule, not the UI locale bundle. */
export function resolveSiteLanguage(): 'en' | 'tr' {
  try {
    const pathname =
      typeof globalThis === 'object' && 'location' in globalThis
        ? ((globalThis as typeof globalThis & { location?: { pathname?: string } }).location
            ?.pathname ?? '')
        : ''
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return timezone === 'Europe/Istanbul' || pathname.split('/')[1] === 'tr' ? 'tr' : 'en'
  } catch {
    return 'en'
  }
}
